import { DecimalPipe } from '@angular/common';
import { CurrencyPipe } from '@angular/common';
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { ComponentsModule } from "./components/components.module";
import { AuthGuard } from "./core/auth.guard";
import { TokenInterceptorService } from "./core/token-interceptor.service";
import { PasswordValidatorDirective } from "./directives/password-validator.directive";
import { AngularMaterialModule } from "./modules/angular-material/angular-material.module";
import { BreakdownModule } from './modules/breakdown/breakdown.module';
import { NumberFormatorDirectiveModule } from './directives/number-format.directive';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

@NgModule({
  declarations: [AppComponent, PasswordValidatorDirective],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    ComponentsModule,
    NumberFormatorDirectiveModule,
    BreakdownModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    AuthGuard,
    CurrencyPipe,
    DecimalPipe,
    provideAnimationsAsync()
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
